import { render, staticRenderFns } from "./lrLayout.vue?vue&type=template&id=53174fd5&"
import script from "./lrLayout.vue?vue&type=script&lang=js&"
export * from "./lrLayout.vue?vue&type=script&lang=js&"
import style0 from "./lrLayout.vue?vue&type=style&index=0&id=53174fd5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports